export const Delete = () => {
    return (
        <svg className={"delete-icon"} width="17.768" height="20" viewBox="0 0 17.768 20">
            <path
                d="M8.656-4.146a2.063,2.063,0,0,1-1.514-.628,2.063,2.063,0,0,1-.628-1.514V-21.321H5.33V-23.1h5.33v-1.048h7.107V-23.1H23.1v1.777H21.913V-6.287a2.067,2.067,0,0,1-.622,1.519,2.067,2.067,0,0,1-1.519.622H8.656ZM20.137-21.321H8.292V-6.287a.355.355,0,0,0,.1.262.355.355,0,0,0,.262.1H19.772a.348.348,0,0,0,.251-.114.348.348,0,0,0,.114-.251Zm-9,13.03h1.777V-18.952H11.139Zm4.374,0h1.777V-18.952H15.513ZM8.292-21.321v0Z"
                transform="translate(-5.33 24.146)"
            />
        </svg>
    );
};
